module.exports = __webpack_public_path__ + "static/media/facebook.dd0b7607.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/social-icons/facebook.svg
// module id = 177
// module chunks = 0